import moment from "moment";
export const getUTCDateTime = (newdate, time) =>{
    let date = moment(newdate).format('MM/DD/YYYY');
    let hour = new Date(`${date} ${time}`).getUTCHours();
    let min = new Date(`${date} ${time}`).getUTCMinutes();
    let dateUTC = new Date(`${date} ${time}`).getUTCDate();
    let monthUTC = new Date(`${date} ${time}`).getUTCMonth();
    let yearUTC = new Date(`${date} ${time}`).getUTCFullYear();
    let newTime = new Date(`${monthUTC +1 }/${dateUTC}/${yearUTC} UTC`).getTime()
  
    return {
      date:newTime,
      time:`${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0'+min }:00`,
      newDate: new Date(`${monthUTC +1 }/${dateUTC}/${yearUTC} UTC`)
    }
  }
  
 export const getLocalDateTime= (newdate, time) =>{
    let date = moment(newdate).format('MM/DD/YYYY');
    let hour = new Date(`${date} ${time} UTC`).getHours();
    let min = new Date(`${date} ${time} UTC`).getMinutes();
    let dateUTC = new Date(`${date} ${time} UTC`).getDate();
    let monthUTC = new Date(`${date} ${time} UTC`).getMonth();
    let yearUTC = new Date(`${date} ${time} UTC`).getFullYear();
    let newTime = new Date(`${monthUTC +1 }/${dateUTC}/${yearUTC} UTC`).getTime()
  
    return {
      date:newTime,
      time:`${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0'+min }:00`,
      newDate:new Date(`${monthUTC +1 }/${dateUTC}/${yearUTC} UTC`)
    }
  }